// extracted by mini-css-extract-plugin
export default {"ProjectsList":"ProjectsList_ProjectsList__h-x-R"};